exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.link-mini-product{display:inline-block;padding:10px 20px;color:#fff;background:#2368ac;margin:20px 20px 0 0}a.link-mini-product:hover{text-decoration:none;background:#004d80}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/style/Product.scss
// module id = 35
// module chunks = 0